import React from "react";
import Modal, { ModalTransition, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "@atlaskit/modal-dialog";
import Button from "@atlaskit/button/new";
import { useEscapeShortcut } from "../utils/keybindings";

export const ACTION_DELETE = "delete";
export const ACTION_DISCARD = "discard";
export const ACTION_CANCEL = "cancel";

const ConfirmModal = ({ action, targetName, targetId, isOpen, onAction, onClose, additionalDescription }) => {
  const ACTION_LABEL = "Confirm " + action;
  const CLOSE_BUTTON_LABEL = "Close";

  useEscapeShortcut(onClose);
  return (
    <ModalTransition>
      {isOpen && (
        <Modal shouldCloseOnOverlayClick={false} width={600}>
          <ModalHeader>
            <ModalTitle>{ACTION_LABEL}</ModalTitle>
          </ModalHeader>
          <ModalBody>
            Are you sure you want to {action} <b>{targetName}</b>?<br />
            {additionalDescription}
          </ModalBody>
          <ModalFooter>
            <Button appearance="subtle" onClick={onClose}>
              {CLOSE_BUTTON_LABEL}
            </Button>
            <Button appearance="primary" onClick={() => onAction(targetId)}>
              {ACTION_LABEL}
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </ModalTransition>
  );
};
export default ConfirmModal;
